<template>
  <v-content >
    <!-- style="position: relative;height: 100vh;" -->    
    <v-card 
      style=height:100%
      flat
      tile
    >
      <router-view />
    </v-card>
  </v-content>
</template>


<script>
import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState(['drawer'])  
  },
  methods: {
    ...mapMutations([
      'showDrawer'
    ])
  }  
}
</script>
